import React from 'react';
import styled from 'styled-components';

const DoubledBedIconSVG = styled.svg(
  props => `
  height: ${props.height};
  fill: ${props.fill};
`,
);

// 🐨 type props as 'themeprops' + 'valid css props'
const DoubleBedIcon = props => (
  <DoubledBedIconSVG viewBox="0 0 32 32" {...props}>
    <path d="M30 15.667H2a2 2 0 00-2 2V23a1.998 1.998 0 001.5 1.933.667.667 0 01.5.644V27a1.333 1.333 0 002.666 0v-1.333c0-.368.298-.667.667-.667h21.333c.368 0 .667.298.667.667V27a1.333 1.333 0 002.666 0v-1.419a.667.667 0 01.5-.644 2 2 0 001.5-1.937v-5.333a2 2 0 00-2-2zm-26.667-2c0 .368.298.667.667.667h24a.667.667 0 00.667-.667V7a3.333 3.333 0 00-3.333-3.333H6.667A3.333 3.333 0 003.334 7zm5.334-4h2.667c1.191 0 2.292.635 2.888 1.667a.667.667 0 01-.577 1H6.357a.667.667 0 01-.578-1 3.335 3.335 0 012.888-1.667zm12 0h2.667c1.191 0 2.292.635 2.888 1.667a.667.667 0 01-.577 1h-7.288a.667.667 0 01-.578-1 3.335 3.335 0 012.888-1.667z" />
  </DoubledBedIconSVG>
);

export default DoubleBedIcon;
